// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-popover.reservation-preview[data-v-53dd58aa]{min-width:550px;width:550px}[data-v-53dd58aa] .popover-body{padding:0}[data-v-53dd58aa] .custom-flex .bv-no-focus-ring{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[data-v-53dd58aa] h3.popover-header{font-size:.85rem}", ""]);
// Exports
module.exports = exports;
